package com.arena_web.data.api

import io.ktor.client.*

class MediaApi(private val client: HttpClient) {
    // Media upload endpoints use multipart form data.
    // Implement upload methods per-feature as needed using Ktor's submitFormWithBinaryData.
}
